import ErrorComponent from "@src/components/errors";
import { lazy } from "react";

import DashboardRedirect from "./components/dashboard-redirect";
import protectedMemberRoutes from "./modules/main/router/protected-routes";
import unprotectedMemberRoutes from "./modules/main/router/unprotected-routes";
import { NEW_ORGANIZATION_PATH } from "./modules/settings/router/paths";
import protectedMemberSettingsRoutes from "./modules/settings/router/protected-routes";

const NewOrganization = lazy(
  () =>
    import("@src/modules/member/modules/settings/organization/new-organization"),
);

const routes = [
  {
    path: "",
    errorElement: <ErrorComponent />,
    children: [
      {
        index: true,
        element: <DashboardRedirect />,
      },
      ...protectedMemberRoutes,
      ...protectedMemberSettingsRoutes,
    ],
  },
  {
    path: NEW_ORGANIZATION_PATH(),
    element: <NewOrganization />,
  },
  ...unprotectedMemberRoutes,
];

export default routes;
